/* eslint-disable semi */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import {
	H1,
	H2,
	H3,
	H4,
	H5,
	H6,
	Paragraph,
	OrderedList,
	UnorderedList,
	ListItem
} from 'components/core/Typography';
import { Group } from 'components/core/Page';
import './MarkdownWrapper.scss';
import Link from 'components/core/Link/Link';

const markdownComponentMap = {
	h1: (props) => <H1 className="ss-type-large" {...props} />,
	h2: (props) => (
		<div style={{ paddingBottom: 'inherit' }} className="card-title">
			<H2 className="ss-type-large" {...props} />
		</div>),
	h3: (props) => <H3 className="ss-type-medium" {...props} />,
	h4: (props) => (
		<div style={{ paddingBottom: 'inherit' }} className="card-title">
			<H4 className="ss-type-medium" {...props} />
		</div>),
	h5: (props) => <H5 className="ss-type-small" {...props} />,
	h6: (props) => (
		<div style={{ paddingBottom: 'inherit' }} className="card-title">
			<H6 className="ss-type-small" {...props} />
		</div>),
	p: (props) => <Paragraph {...props} />,
	ol: (props) => <OrderedList {...props} />,
	ul: (props) => <UnorderedList {...props} />,
	li: (props) => <ListItem {...props} />,
	a: (props) => <Link {...props} />
};
export default function MarkdownWrapper({ content, components, ...args }) {
	const mergedComponents = { ...markdownComponentMap, ...components };

	return (
		<div className="search-boilerplate">
			{content && content.map((item) => (
				<Group key={item.value}>
					<ReactMarkdown
						components={mergedComponents}
						{...args}
					>
						{item.value}
					</ReactMarkdown>
				</Group>
			))}
		</div>
	)
}

MarkdownWrapper.propTypes = {
	content: PropTypes.arrayOf(PropTypes.object),
	components: PropTypes.objectOf(PropTypes.Component)
};
